import "./style.css";
import { useAuthStore } from "stores/auth/authStore";
import LocationPicImg from "assets/images/pin-location.png";
import { formatName } from "utils/index";

export const EventsDealer = () => {
  const subdomain = useAuthStore(state => state.domain);

  return (
    <>
      <div className="flex mx-auto justify-center md:mt-auto w-full">
        <div className="find-event_main mt-[140px] lg:mt-[102px]">
          <div className="flex flex-col lg:items-start w-[620px] xl:w-auto">
            <h1 className="find-event-text">
              Find a {subdomain ? subdomain: "SaddleFit"} Event Near you
            </h1>
            <p className="events_descrip">
              Use this map to find a {subdomain ? formatName(subdomain): "SaddleFit"} event near you where you can have
              your horse 3D scanned. Take the guesswork out of finding your
              best fitting saddle with {subdomain ? formatName(subdomain): "SaddleFit"}.
            </p>
          </div>
          <img src={LocationPicImg} alt="pin" className="lg:block hidden" />
        </div>
      </div>
    </>
  );
};
